var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg401Unauthorized(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBEBEB;}\n\t.st1{fill:#DBDBDB;}\n\t.st2{fill:#C7C7C7;}\n\t.st3{fill:#A6A6A6;}\n\t.st4{fill:#263238;}\n\t.st5{fill:#DF0C00;}\n\t.st6{fill:#455A64;}\n\t.st7{fill:#37474F;}\n\t.st8{fill:#FFFFFF;}\n\t.st9{fill:#F4996C;}\n\t.st10{fill:#FF9CBD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.7,
    y: 198.9,
    className: "st0",
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 213,
    className: "st0",
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 213,
    className: "st0",
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.8,
    y: 213,
    className: "st0",
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.8,
    y: 34.5,
    className: "st0",
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.6,
    y: 48.6,
    className: "st0",
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34.5,
    className: "st0",
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.4,
    y: 107.3,
    className: "st0",
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.2,
    y: 93.2,
    className: "st0",
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 92.6,
    className: "st0",
    width: 177.5,
    height: 7.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 100.3,
    className: "st0",
    width: 7.8,
    height: 25.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 100.3,
    className: "st1",
    width: 7.8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.8,
    y: 100.3,
    className: "st0",
    width: 7.8,
    height: 25.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.8,
    y: 100.3,
    className: "st1",
    width: 7.8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.1,
    y: 43,
    className: "st2",
    width: 12.5,
    height: 49.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.1,
    y: 40.3,
    className: "st1",
    width: 12.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.1,
    y: 52.7,
    className: "st1",
    width: 12.5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.1,
    y: 80.6,
    className: "st1",
    width: 14.1,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.6,
    y: 34.7,
    className: "st1",
    width: 8.7,
    height: 57.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.3,
    y: 40.1,
    className: "st0",
    width: 5.2,
    height: 22.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.5,
    y: 40.2,
    transform: "matrix(0.703 -0.7112 0.7112 0.703 52.6715 264.3535)",
    className: "st2",
    width: 8.7,
    height: 57.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.3,
    y: 61,
    transform: "matrix(0.703 -0.7112 0.7112 0.703 51.4082 267.3954)",
    className: "st1",
    width: 5.2,
    height: 22.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.4,
    y: 48.6,
    className: "st3",
    width: 14.8,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.4,
    y: 83.8,
    className: "st2",
    width: 14.8,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.4,
    y: 79.5,
    className: "st2",
    width: 14.8,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.9,
    y: 51.3,
    className: "st3",
    width: 10.2,
    height: 41.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.9,
    y: 84.3,
    className: "st2",
    width: 10.2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.9,
    y: 59.8,
    className: "st2",
    width: 10.2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.9,
    y: 66.3,
    className: "st2",
    width: 10.2,
    height: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "408.9,73.3 407.8,76.3 407.1,78.1 406,81 401.6,92.6 378,92.6 373.6,81 372.5,78.1 371.8,76.3  370.7,73.3 379.4,60.6 374.9,52.3 404.7,52.3 400.2,60.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "408.9,73.3 407.8,76.3 371.8,76.3 370.7,73.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "407.1,78.1 406,81 373.6,81 372.5,78.1  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "29.7,356.5 84.8,356.3 139.9,356.2 250,356 360.1,356.2 415.2,356.3 470.3,356.5 415.2,356.8  360.1,356.8 250,357 139.9,356.8 84.8,356.8  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.1,366c0,3.6-18,6.6-40.2,6.6s-40.2-3-40.2-6.6s18-6.6,40.2-6.6S109.1,362.3,109.1,366z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M71.2,280.9c-1.1,4.1-1.9,8.2-2.2,12.5c0.1,0.2,0.1,1,0,0.8c0,0.7-1.1,0.6-1.1-0.1c0-0.4,0-0.9,0-1.3 c-2.4-3-6-4.9-8.8-7.6c-2.3-2.1-4-4.7-4.8-7.7c-2.4-8.2-0.2-16.8-3-25c-2.5-7-6.9-13.1-10.6-19.5c-3.9-6.7-6.8-13.8-7.1-21.7 c-0.2-6,0.5-14.1,5.1-18.6c4.9-4.8,10.9-1.2,14.7,3.1c10.8,12.4,15.8,28.1,17.8,44.1c1.1,8.9,2.3,17.8,2,26.8 C73,271.5,72.3,276.3,71.2,280.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.1,296.6c0.6-8.4,0.5-16.8-0.3-25.1v-0.1c0.1-6.8,0.7-13.6,0.4-20.4c-0.3-7.4-1.3-14.7-3-21.9 c0-0.1-0.2-0.1-0.1,0c1.3,7.1,2.1,14.2,2.4,21.4c0.1,3.8,0.1,7.7-0.1,11.5c-0.1,1.3-0.2,2.5-0.3,3.8l0,0 c-2.8-19.1-9.7-37.3-20.2-53.5c-0.1-0.2-0.5,0-0.4,0.3c7.5,12.3,13,25.7,16.5,39.7c-5.2-9.6-13-17.6-18.9-26.8c0-0.1-0.1,0-0.1,0.1 c5.2,10.3,13.9,18.4,19.4,28.6c0.9,4.1,1.7,8.3,2.3,12.5c0.8,5.8,1.2,11.6,1.3,17.4c-3.2-5.9-6.5-11.6-9-17.8 c-0.1-0.2-0.3-0.1-0.3,0.1c2.2,6.5,5.2,13.5,9.3,19.1c0,4.1-0.1,8.2-0.3,12.3c-0.7,11-2.5,21.8-3.4,32.8c0,0.1,0.1,0.3,0.2,0.3 s0.3-0.1,0.3-0.2C67,319.3,68.4,308,69.1,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.4,212c0-0.1-0.2,0-0.1,0.1c2,5.5,3.1,11.2,4.6,16.8c0,0.1,0.2,0.2,0.3,0.1c0.1,0,0.1-0.1,0.1-0.2 C61.7,223.1,59.6,217.3,57.4,212z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.3,235.2c-1.3,3.3-2.9,6.4-4.6,9.5c-3.6,6.6-7.4,12.6-8.1,20.2c-0.3,3.4-0.4,6.8-1.4,10.1 c-0.9,2.8-2.3,5.5-4,7.9c-3.9,5.7-8.8,10.6-12.4,16.5c-3.8,6.2-6.6,12.9-8.3,19.9c-0.1,0.4-0.7,0.3-0.6-0.1v-0.1V319 c-0.6-16.4,0.7-32.9,5.7-48.5c2.2-6.9,4.9-13.6,7.9-20.2c2.7-5.7,6-11.2,10.7-15.4c3.1-2.8,9.7-8,14-5.2 C109.3,231.1,109.1,233.2,108.3,235.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.9,272.3c-2.9,4.7-6.1,9.3-9.5,13.7c-1.6,2.1-3.2,4.1-4.8,6.2c-0.8,1-1.6,2-2.3,3c0.4-1.7,0.8-3.4,1.3-5.2 c2.1-8.3,4.1-16.6,7.3-24.6c3.2-7.7,7-15.2,11.4-22.3c0.1-0.2-0.2-0.3-0.3-0.1c-3.5,5.7-7,11.4-9.9,17.4c-1.6,3.3-3,6.8-4.2,10.3 c1.3-7.5,3.2-14.8,5.6-22c0-0.1-0.1-0.1-0.1,0c-3.1,7.3-5.1,15-5.8,22.9l0,0c-0.7,2.1-1.4,4.3-2,6.4c-2.6,9.2-4.8,18.4-6.9,27.7 c0-6.1,0.5-12.2,1.6-18.2c0-0.1,0-0.1-0.1-0.1s-0.1,0-0.1,0.1c-1.6,6.3-2.1,12.8-1.6,19.2c-0.8,3.5-1.6,7.1-2.3,10.6 c-1.6,7.5-3.6,15.2-4.5,22.9c0,0.1,0.1,0.2,0.2,0.2s0.1,0,0.1-0.1c1.1-4.1,1.8-8.4,2.7-12.6s1.9-8.4,2.8-12.6 c1.4-6.1,2.9-12.2,4.4-18.2c1-2.2,3-4.2,4.4-6.1c1.6-2,3.2-4.1,4.8-6.2C87.1,280.7,89.7,276.6,91.9,272.3 C92.1,272.3,91.9,272.2,91.9,272.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.6,265.3c-3.6,4.6-6.7,9.6-9.3,14.8c0,0.1,0.1,0.1,0.1,0.1c3.1-4.9,6.2-9.9,9.3-14.8 C92.8,265.3,92.6,265.3,92.6,265.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.9,250.7c2.1,3.7,4.5,8,3.6,12.4c-0.6,2.8-2.6,5-3,7.9c-0.8,6.3,5.4,10.4,9.9,13.3 c11.2,7.4,26.7,14,28.7,29c0.1,0.5,1,0.4,0.9-0.1v-0.1c0,0,0.1,0,0.1-0.1c1.5-7.6,1.4-15.4-0.2-23c-1.7-7.8-5.1-14.7-9.1-21.6 C47,256.9,39.9,245,29.7,236.2c-2.8-2.4-8.6-6.8-10.9-1.3C16.6,240.4,20.3,246.3,22.9,250.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.2,275.2c7.5,8.1,19.3,12.6,25.7,21.6c-3.6-13.8-10.3-26.5-19.8-37.1c-0.1-0.1-0.1-0.3,0-0.4s0.3-0.1,0.4,0 c6.9,6.7,12.3,14.6,16.1,23.4c-1.8-6.1-4.1-12.1-7-17.8c-0.1-0.1,0-0.2,0.1-0.3s0.2,0,0.3,0.1c3.5,6.2,6.1,13,7.5,20 c8.4,20.5,9.2,44.5,7.5,66c0,0.3-0.5,0.3-0.5,0c0.5-17,0.2-34.3-3.9-50.9l-0.3-1c-7-9.7-18.8-14.2-26.4-23.5 C33,275.3,33.1,275.1,33.2,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.4,268.3c3.9,3.6,7.8,7.3,11.7,10.9c0,0,0,0.1-0.1,0.1c-4.4-3-8.4-6.6-11.8-10.7c-0.1-0.1-0.1-0.2,0-0.2 S31.4,268.2,31.4,268.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M30.8,252.7c3.5,5.7,7.4,11.1,11.7,16.1c0,0.1,0,0.2-0.1,0.1c-4.9-4.6-8.9-10.1-11.8-16.1c0-0.1,0-0.1,0-0.2 S30.8,252.7,30.8,252.7L30.8,252.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "48.4,366 82.7,366 78.1,319.9 53.7,319.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "52.8,327.3 78.8,327.3 78.1,319.8 53.7,319.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 314.7,
    className: "st6",
    width: 32.1,
    height: 7.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sofa--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.4,
    y: 234.8,
    className: "st1",
    width: 300.8,
    height: 152.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.2,
    y: 284.6,
    className: "st1",
    width: 39.2,
    height: 102.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.3,
    y: 284.6,
    className: "st1",
    width: 39.2,
    height: 102.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.4,
    y: 234.8,
    className: "st2",
    width: 0.9,
    height: 122.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 284.6,
    className: "st2",
    width: 0.9,
    height: 102.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.8,
    y: 284.6,
    className: "st2",
    width: 0.9,
    height: 102.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251.3,357.6H100v-31.9h151.3V357.6z M100.9,356.6h149.4v-30H100.9V356.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M401.7,357.6H250.4v-31.9h151.3V357.6z M251.3,356.6h149.4v-30H251.3V356.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.7,268.4c-0.4,0-0.6,0.3-0.6,0.7c0,0.4,0.3,0.6,0.6,0.6c0.4,0,0.6-0.3,0.6-0.7 C111.3,268.7,111,268.4,110.7,268.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.8,347.8c-0.4,0-0.6,0.3-0.6,0.7c0,0.4,0.3,0.6,0.6,0.6c0.4,0,0.6-0.3,0.6-0.7 C112.4,348.1,112.1,347.8,111.8,347.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149,335.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.3-0.2-0.4-0.1l-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2 C147.9,336.2,149.4,336.2,149,335.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.2,349.5c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.3-0.2-0.4-0.1l-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2 C83.1,350.3,84.6,350.3,84.2,349.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.2,272.4c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5S116.5,272.4,116.2,272.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M319,288.5c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5S319.3,288.5,319,288.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.5,322.7c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5S74.8,322.7,74.5,322.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139.6,244.7c-0.3-0.3-0.7-0.3-1,0l0,0c-0.2,0.3-0.3,0.6-0.2,0.9c0.1,0.4,0.5,0.6,0.9,0.5 c0.2-0.1,0.4-0.3,0.5-0.5C140,245.3,139.9,244.9,139.6,244.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.2,344.2c-0.3-0.3-0.7-0.3-1,0l0,0c-0.2,0.2-0.3,0.6-0.2,0.9c0.1,0.4,0.5,0.6,0.9,0.5 c0.2-0.1,0.4-0.3,0.5-0.5C117.5,344.8,117.4,344.4,117.2,344.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M374,349.6c0.4,0,0.6-0.4,0.6-0.7c0-0.3-0.3-0.5-0.6-0.6c-0.4,0-0.6,0.4-0.6,0.7 C373.5,349.3,373.7,349.5,374,349.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M239.4,350.9c0.4,0,0.6-0.3,0.6-0.7c0-0.4-0.3-0.6-0.6-0.6c-0.4,0-0.6,0.3-0.6,0.7 C238.7,350.6,239,350.9,239.4,350.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M370.3,246.4c0.4,0,0.6-0.3,0.6-0.7s-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6C369.6,246.1,369.9,246.4,370.3,246.4 L370.3,246.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.1,264.2c0.4,0,0.6-0.3,0.6-0.7c0-0.4-0.3-0.6-0.6-0.6c-0.4,0-0.6,0.3-0.6,0.7 C206.4,263.9,206.7,264.2,207.1,264.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M326.1,282.5c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.3,0.2,0.4,0.1l0.1-0.1c0-0.1,0.1-0.1,0.1-0.2 C327.2,281.8,325.7,281.8,326.1,282.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.5,344.7c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.3,0.2,0.4,0.1l0.1-0.1l0.1-0.2C268.6,344,267.2,344,267.5,344.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M423,333c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.3,0.2,0.4,0.1l0.1-0.1c0-0.1,0.1-0.1,0.1-0.2 C424.1,332.2,422.6,332.2,423,333z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M368.4,345.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5S368.2,345.6,368.4,345.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M410.1,295.3c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5S409.9,295.3,410.1,295.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M413.7,361.8c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5S413.4,361.8,413.7,361.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M335.5,373.3c0.3,0.3,0.7,0.3,1,0l0,0c0.2-0.3,0.3-0.6,0.2-0.9c-0.1-0.4-0.5-0.6-0.9-0.5 c-0.2,0.1-0.4,0.3-0.5,0.5C335.2,372.7,335.2,373,335.5,373.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M367.5,273.8c0.3,0.3,0.7,0.3,1,0l0,0c0.2-0.3,0.3-0.6,0.2-0.9c-0.1-0.4-0.5-0.6-0.9-0.5 c-0.2,0.1-0.4,0.3-0.5,0.5C367.2,273.2,367.2,273.5,367.5,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187.3,305.6c0.3,0.3,0.7,0.3,1,0l0,0c0.2-0.3,0.3-0.6,0.2-0.9c-0.1-0.4-0.5-0.6-0.9-0.5 c-0.2,0.1-0.4,0.3-0.5,0.5C187,305,187,305.4,187.3,305.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M426.9,326.5c0.3,0.3,0.7,0.3,1,0l0,0c0.2-0.3,0.3-0.6,0.2-0.9c-0.1-0.4-0.5-0.6-0.9-0.5 c-0.2,0.1-0.4,0.3-0.5,0.5C426.6,325.9,426.7,326.3,426.9,326.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.9,356.7c24.5,5.8,49.5,8.8,74.7,8.9c25.5-0.2,50.9-3,75.7-8.5L100.9,356.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.8,356.7c24.5,5.8,49.5,8.8,74.7,8.9c25.5-0.2,50.9-3,75.7-8.5L250.8,356.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.2,
    y: 378.4,
    className: "st7",
    width: 379.3,
    height: 9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "113.8,387.5 103.8,407.9 93.8,428.4 85,428.4 88.3,407.9 91.5,387.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.5,387.5 113.8,387.5 107.7,399.8 89.6,399.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "412.9,428.4 404.2,428.4 394.2,407.9 384.2,387.5 406.5,387.5 409.7,407.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "408.4,399.8 390.2,399.8 384.2,387.5 406.4,387.5  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Browser--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.6,
    y: 126,
    className: "st8",
    width: 364.7,
    height: 37.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M432.9,164.2H67.1v-38.8h365.7L432.9,164.2L432.9,164.2z M68.1,163.2h363.7v-36.8H68.1V163.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.6,
    y: 126,
    className: "st5",
    width: 37.8,
    height: 37.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M424.2,154.6L421,157l-5.9-7.8l-2.2-2.9c1.3-0.5,2.3-1.5,2.9-2.8l2.3,3L424.2,154.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M417.9,136.1c-2.9-3.8-8.4-4.5-12.3-1.6c-3.8,2.9-4.5,8.4-1.6,12.3c2.6,3.4,7.3,4.4,11,2.4 c1.2-0.7,2.2-1.6,3-2.7C420.3,143.4,420.2,139.2,417.9,136.1z M414.1,145.6c-0.4,0.3-0.8,0.5-1.2,0.7c-2.7,1.1-5.7-0.2-6.8-2.9 s0.2-5.7,2.9-6.8c2.7-1.1,5.7,0.2,6.8,2.9c0.5,1.3,0.5,2.7,0,3.9C415.4,144.3,414.9,145,414.1,145.6L414.1,145.6z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M472.4,212.7c-1.9-1.4-63.4-20.5-66.2-19.7c-0.3,0.1-1,2.9-3.7,9.7c-0.1,0.3-29.4,35.8-29.4,35.8l40,21.1 l22.9-32.3c0,0,28.6-5.4,31.6-6.6S474.3,214.1,472.4,212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M472.4,212.7c-1.9-1.4-63.4-20.5-66.2-19.7c-0.3,0.1-1,2.9-3.7,9.7c-0.1,0.3-4.1,5-6.1,7.5 c2.5,2.2,27.1,19.5,33.9,25.3l5.8-8.1c0,0,28.6-5.4,31.6-6.6S474.3,214.1,472.4,212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M417.9,199c-0.3,0.7-0.7,1.4-1.2,2c-0.9,1.2-2.1,2.2-3.5,2.9s-3,0.9-4.5,0.8c-1.5-0.2-3-0.6-4.3-1.4 c-0.1,0,0-0.1,0.1-0.1c4.1,2,9,0.8,11.6-2.9c0.4-0.6,0.7-1.1,1-1.8c0.1-0.3,0.3-0.7,0.4-1s0.1-0.6,0.5-0.8c0.2-0.1,0.3,0,0.4,0.1 C418.7,197.4,418.1,198.4,417.9,199z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M459.5,222.7c-1.4-0.5-2.5-1.4-3.3-2.6c-0.9-1.2-1.6-2.5-2.2-3.9s-1-2.8-1.2-4.3c-0.1-0.7-0.2-1.4-0.2-2.2 c-0.1-0.7,0-1.5,0.1-2.2c0-0.1,0.1-0.1,0.2-0.1c0,0,0.1,0,0.1,0.1c0.1,0.6,0.2,1.3,0.2,1.9c0.1,0.7,0.2,1.4,0.3,2.1 c0.3,1.4,0.7,2.7,1.2,4c1,2.6,2.7,4.9,5.1,6.5c0.2,0.1,0.2,0.3,0.2,0.4C459.8,222.7,459.6,222.7,459.5,222.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M430.2,228.1c-7.5-5.4-14.9-10.8-22.5-16.2c-2.1-1.5-4.3-3-6.4-4.5c-0.1-0.1,0-0.1,0.1-0.1 c7.9,4.8,15.6,9.9,22.9,15.5c2.1,1.6,4.1,3.3,6.1,5C430.7,227.9,430.4,228.2,430.2,228.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M402.1,208.6c0,0.1-0.1,0.1-0.1,0.1l-0.2,0.1l-0.3,0.2c-0.2,0.1-0.5,0.3-0.7,0.4c-0.5,0.3-0.9,0.5-1.4,0.7 c-0.1,0-0.1-0.1-0.1-0.1c0.5-0.3,0.9-0.6,1.3-0.9l0.6-0.4l0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2C402,208.4,402.1,208.4,402.1,208.6 C402.1,208.5,402.1,208.5,402.1,208.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M405.6,211.1c0,0.1-0.1,0.1-0.1,0.1l-0.2,0.1l-0.3,0.2c-0.2,0.1-0.5,0.3-0.7,0.4c-0.5,0.3-0.9,0.5-1.4,0.7 c-0.1,0-0.1-0.1-0.1-0.1c0.5-0.3,0.9-0.6,1.3-0.9l0.6-0.4l0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.2C405.5,210.9,405.6,211,405.6,211.1 L405.6,211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M409.1,213.7c0,0.1-0.1,0.1-0.1,0.1l-0.2,0.1l-0.3,0.2c-0.2,0.2-0.5,0.3-0.7,0.4c-0.5,0.3-0.9,0.5-1.4,0.7 c-0.1,0-0.1-0.1-0.1-0.1c0.5-0.3,0.9-0.6,1.3-0.9l0.6-0.4l0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2C409,213.5,409.1,213.6,409.1,213.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M412.5,216.3c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1l-0.3,0.2l-0.7,0.4c-0.5,0.3-0.9,0.5-1.4,0.7 c-0.1,0-0.1-0.1-0.1-0.1c0.5-0.3,0.9-0.6,1.3-0.9l0.6-0.4l0.3-0.2c0.1-0.1,0.2-0.1,0.4-0.2C412.5,216.1,412.6,216.2,412.5,216.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M416,218.9c0,0.1-0.1,0.1-0.1,0.1l-0.2,0.1c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0.1-0.5,0.3-0.7,0.4 c-0.5,0.3-0.9,0.5-1.4,0.7c-0.1,0-0.1-0.1-0.1-0.1c0.5-0.3,0.9-0.6,1.3-0.9l0.6-0.4l0.3-0.2c0.1-0.1,0.2-0.1,0.4-0.2 C415.9,218.7,416,218.7,416,218.9C416,218.8,416,218.8,416,218.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M419.5,221.4c0,0.1-0.1,0.1-0.1,0.1l-0.2,0.1l-0.3,0.2c-0.2,0.1-0.5,0.3-0.7,0.4c-0.5,0.3-0.9,0.5-1.4,0.7 c-0.1,0-0.1-0.1-0.1-0.1c0.5-0.3,0.9-0.6,1.3-0.9l0.6-0.4l0.3-0.2c0.1-0.1,0.2-0.1,0.4-0.2C419.5,221.2,419.5,221.3,419.5,221.4 L419.5,221.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M423,224c0,0.1-0.1,0.1-0.1,0.1l-0.2,0.1l-0.3,0.2c-0.2,0.2-0.5,0.3-0.7,0.4c-0.5,0.3-0.9,0.5-1.4,0.7 c-0.1,0-0.1-0.1-0.1-0.1c0.4-0.3,0.9-0.6,1.3-0.9l0.6-0.4c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.1,0.4-0.2 C423,223.8,423.1,223.9,423,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M426.5,226.6c0,0.1-0.1,0.1-0.1,0.1l-0.2,0.1l-0.3,0.2l-0.7,0.4c-0.5,0.3-0.9,0.5-1.4,0.7 c-0.1,0-0.1-0.1-0.1-0.1c0.5-0.3,0.9-0.6,1.3-0.9l0.6-0.4l0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2C426.5,226.4,426.5,226.5,426.5,226.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M430,229.1c0,0.1-0.1,0.1-0.1,0.1l-0.2,0.1l-0.3,0.2c-0.2,0.1-0.5,0.3-0.7,0.4c-0.5,0.3-0.9,0.5-1.4,0.7 c-0.1,0-0.1-0.1-0.1-0.1c0.5-0.3,0.9-0.6,1.3-0.9l0.6-0.4l0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.2C429.9,229,430,229,430,229.1L430,229.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M427.2,248.1l-37.6-32c0,0-36.3,46.4-36.9,46.7c0,0-25.5,6.1-48.2,8.2c-4.2,0.4-30.7-8.5-50.4,7.4l3.7,38.3 c38.5,5.5,92.2-2.8,115-10.3C394.4,299.4,427.2,248.1,427.2,248.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M420,247.5c-8-6.6-16-13-24.3-19.1c-2.4-1.7-4.8-3.4-7.2-5.1c-0.1-0.1-0.2,0.1-0.1,0.1c2,1.6,4,3.3,6,4.9 s4,3.3,6,4.9c4,3.2,8.2,6.2,12.3,9.3c2.4,1.7,4.8,3.4,7.1,5.1C420,247.7,420,247.6,420,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M394.5,233.2c-6.4,8.5-12.8,16.9-19.1,25.4c-3.2,4.2-6.3,8.5-9.5,12.7c-1.4,1.9-2.8,3.6-5.1,4.3 c-1.2,0.3-2.3,0.5-3.5,0.6l-3.9,0.5c-10.4,1.3-20.9,2.6-31.3,3.9c-2.6,0.4-5.2,0.6-7.9,0.6c-2.6-0.1-5.2-0.5-7.8-1 c-4.7-0.8-9.4-1-14.2-0.8c-9.4,0.7-18.5,3.2-27,7.3c-1.1,0.5-2.1,1-3.2,1.6c-0.1,0,0,0.2,0.1,0.1c8.7-4.3,18.1-7,27.8-8 c4.8-0.5,9.5-0.4,14.3,0.3c2.5,0.4,5,0.9,7.6,1.2c2.6,0.2,5.2,0.1,7.9-0.2c5.3-0.5,10.5-1.3,15.7-1.9l15.7-1.9 c2.6-0.3,5.2-0.6,7.8-1c2.1-0.2,4.1-1.1,5.7-2.5c1.6-1.8,3-3.7,4.3-5.7c1.6-2.2,3.2-4.4,4.8-6.5c6.3-8.5,12.5-17,18.8-25.6l2.3-3.2 C394.8,233.3,394.6,233.1,394.5,233.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M372.5,145.8c-2,1.3-41.4,52.2-41.7,55.1c0,0.3,2.3,1.9,7.8,6.9c0.3,0.2,0.5,2.2,0.8,5.2 c0.9,11.2,1.7,36.5,1.7,36.5l41.3-10.2l-7.1-43l-1.8-11.3c0,0,4.9-28.7,4.9-31.9S374.5,144.4,372.5,145.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M372.5,145.8c-2,1.3-41.4,52.2-41.7,55.1c0,0.3,2.3,1.9,7.8,6.9c0.3,0.2,0.5,2.2,0.8,5.2 c6.8-3.3,27.5-12.9,35.9-16.7l-1.8-11.2c0,0,4.9-28.7,4.9-31.9S374.5,144.4,372.5,145.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M340.5,192c0.5,0.5,1,1.1,1.4,1.8c0.8,1.3,1.3,2.8,1.4,4.3s-0.2,3.1-0.8,4.5c-0.7,1.4-1.6,2.6-2.8,3.6 c-0.1,0-0.1-0.1-0.1-0.1c2.2-2.1,3.2-5,2.8-8c-0.2-1.4-0.7-2.7-1.4-3.9c-0.4-0.6-0.8-1.1-1.3-1.6c-0.2-0.2-0.5-0.5-0.8-0.7 s-0.5-0.3-0.6-0.7c0-0.2,0.1-0.3,0.3-0.4C339.4,190.7,340.1,191.6,340.5,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M377.3,161.4c-1,1.1-2.2,1.9-3.6,2.2c-1.5,0.4-2.9,0.7-4.5,0.7c-1.5,0.1-3-0.1-4.4-0.4 c-0.7-0.2-1.4-0.4-2.1-0.6c-0.7-0.2-1.4-0.5-2-0.9c-0.1,0-0.1-0.1,0-0.2h0.1c0.6,0.1,1.3,0.4,1.9,0.5c0.7,0.2,1.4,0.3,2.1,0.4 c1.4,0.2,2.8,0.3,4.2,0.3c2.8,0,5.6-0.8,7.9-2.5c0.1-0.1,0.3-0.1,0.4,0.1C377.4,161.1,377.4,161.3,377.3,161.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M372.6,192c-8.3,4-16.6,8-24.9,12.1c-2.4,1.2-4.7,2.3-7,3.5c-0.1,0-0.1-0.1,0-0.1c8-4.7,16.2-9,24.6-12.8 c2.4-1.1,4.8-2,7.3-3c0.1,0,0.2,0.1,0.2,0.2C372.7,191.9,372.7,192,372.6,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M342.1,207.5c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2s0,0.3,0,0.4s0,0.5,0,0.8c0,0.5,0,1.1,0,1.6 c0,0.1-0.1,0.1-0.1,0c0-0.5-0.1-1.1-0.1-1.6c0-0.3,0-0.5-0.1-0.8s0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.1,0.1-0.2 C342,207.4,342.1,207.4,342.1,207.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M346,205.6c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4s0,0.6,0,0.8c0,0.5,0,1.1,0,1.6 c0,0.1-0.1,0.1-0.1,0c0-0.5-0.1-1.1-0.1-1.6c0-0.3,0-0.5-0.1-0.8s0-0.3,0-0.4c0-0.1,0-0.3,0-0.4C345.8,205.6,345.9,205.6,346,205.6 L346,205.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M349.9,203.8c0,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4c0,0.3,0,0.6,0,0.8c0,0.5,0,1.1,0,1.6 c0,0.1-0.1,0.1-0.1,0c0-0.5-0.1-1.1-0.1-1.6c0-0.3,0-0.5-0.1-0.8s0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.1,0.1-0.1 S349.9,203.7,349.9,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M353.9,201.9c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2v0.4c0,0.3,0,0.5,0,0.8c0,0.5,0,1.1,0,1.6 c0,0.1-0.1,0.1-0.1,0c0-0.5-0.1-1.1-0.1-1.6c0-0.3-0.1-0.5-0.1-0.8s0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.1,0.1-0.2 S353.9,201.9,353.9,201.9L353.9,201.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M357.8,200.1c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2s0,0.3,0,0.4c0,0.3,0,0.6,0,0.8c0,0.5,0,1.1,0,1.6 c0,0.1-0.1,0.1-0.1,0c0-0.5-0.1-1.1-0.1-1.6c0-0.3,0-0.5-0.1-0.8s0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.1,0.2-0.1 C357.7,200,357.8,200,357.8,200.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M361.7,198.3c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2s0,0.3,0,0.4s0,0.5,0,0.8c0,0.5,0,1.1,0,1.6 c0,0.1-0.1,0.1-0.1,0c0-0.5-0.1-1.1-0.1-1.6c0-0.3,0-0.5-0.1-0.8s0-0.3,0-0.4c0-0.1,0-0.3,0-0.4 C361.5,198.2,361.6,198.2,361.7,198.3C361.7,198.2,361.7,198.2,361.7,198.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M365.6,196.4c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2s0,0.3,0,0.4s0,0.6,0,0.8c0,0.5,0,1.1,0,1.6 c0,0.1-0.1,0.1-0.1,0c0-0.5-0.1-1.1-0.1-1.6c0-0.3,0-0.5-0.1-0.8s0-0.3,0-0.4c0-0.1,0-0.3,0-0.4 C365.4,196.4,365.5,196.3,365.6,196.4L365.6,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M369.5,194.6c0,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4c0,0.3,0,0.6,0,0.8c0,0.5,0,1.1,0,1.6 c0,0-0.1,0.1-0.1,0l0,0c0-0.5-0.1-1.1-0.1-1.6c0-0.3,0-0.5-0.1-0.8s0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.1,0.1-0.1 C369.5,194.4,369.5,194.5,369.5,194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M373.5,192.7c0,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.3,0,0.4c0,0.3,0,0.5,0,0.8c0,0.5,0,1.1,0,1.6 c0,0.1-0.1,0.1-0.1,0c0-0.5-0.1-1.1-0.1-1.6c0-0.3,0-0.5-0.1-0.8s0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.1,0.1-0.2 S373.5,192.6,373.5,192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M377.5,208.3l-41.7,8.9c0,0,5,60.3,4.8,61c0,0-21.3,2.8-38.3,1.9c0,0-28.6-14.4-48.2,7.1l-2.8,37.7 c54.5,6.6,127.5,3.5,137.1-15C399,289.6,377.5,208.3,377.5,208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M340.5,277.9c-4.6,0-12.4,0.9-17,1s-9.2,0.5-13.8,0.7c-2.6,0.1-4.9,0-7.5,0.2c0,0-0.1,0.1,0,0.1l0,0 c9.1,0.5,18.2,0.3,27.2-0.5c2.6-0.2,8.5-0.9,11.1-1.3C340.8,278.2,341,277.9,340.5,277.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M299.7,276c-1.7-1.9-3.6-3.6-5.7-5c-0.1-0.1-0.2,0.1-0.1,0.1c1.8,1.7,3.5,3.6,5.1,5.5c1.7,1.9,3.3,3.9,4.8,6  M303.9,282.6c-1.1-2.3-2.5-4.5-4.2-6.6L303.9,282.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M391.3,281.7c0-2.1-0.2-4.1-0.4-6.2c-0.3-4.1-0.7-8.1-1.3-12.2c-1.1-8.2-2.5-16.3-4.3-24.3 c-0.5-2.2-1-4.5-1.6-6.7c-0.5-2.3-1.2-4.5-1.9-6.8c-0.1-0.2-0.4-0.1-0.4,0.1c0.3,2,0.8,3.9,1.3,5.9s0.9,4,1.3,5.9 c0.9,4,1.6,8.1,2.4,12.2c1.4,8.1,2.6,16.2,3.5,24.4c0.3,2.3,0.5,4.6,0.7,6.9c0.1,1.1,0.6,10.3,0.6,11.5c0,0.1,0.2,0.1,0.1,0 C391.3,291.3,391.4,284.7,391.3,281.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M340.5,271.5c-0.1-1.1-0.5-5.5-0.9-6.3h-0.1c-0.3,1,0.1,5.4,0.2,6.6s0.7,6,0.9,6.3c0,0,0.1,0.1,0.1,0l0,0 C340.8,275.9,340.7,273.7,340.5,271.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M378.9,288.2c-0.2-7.3-0.7-14.7-1.4-22c-1.5-14.4-3.8-28.7-6.4-43c-0.3-1.8-0.6-3.5-0.9-5.3 c0-0.1-0.2-0.1-0.1,0c2.4,14.3,4.8,28.5,6.5,42.9c0.8,7.1,1.4,14.3,1.7,21.5c0.1,3.5,0.2,7,0.2,10.5c0.1,2.9-0.2,5.8-0.8,8.7 c-0.6,2.8-1.9,5.5-3.8,7.6c-2.1,2-4.6,3.6-7.4,4.4c-3,1-6.1,1.8-9.2,2.3c-3.4,0.7-6.9,1.2-10.4,1.7c-14,1.8-28,1.8-42.1,1.5 c-14.4-0.3-28.8-0.8-43.1-1c-1.8,0-3.6,0-5.4-0.1c-0.1,0-0.1,0.1,0,0.1c7.4,0.2,14.8,0.5,22.3,0.8s14.7,0.5,22,0.6 c14.2,0.4,28.4,0.6,42.6-0.9c6.9-0.7,13.7-1.8,20.3-3.5c2.8-0.7,5.5-1.7,8-3.2c2.4-1.5,4.2-3.6,5.4-6.1 C379.4,300.4,379,294,378.9,288.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M377.5,214.8c-10.2,1.6-20.4,3.3-30.4,5.5c-2.9,0.6-5.7,1.4-8.6,2c-0.1,0-0.1,0.2,0,0.1 c2.5-0.5,5.1-0.8,7.7-1.2s5.1-0.8,7.6-1.3c5.1-0.9,10.1-2,15.1-3.1c2.9-0.6,5.7-1.3,8.6-1.9C377.6,215,377.6,215,377.5,214.8 C377.6,214.9,377.6,214.8,377.5,214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M162.7,236.2l6.2,28.4c0.3,0.8-0.2,1.5-1,1.5l-14.5-0.5c-0.9-0.1-1.7-0.7-2-1.6l-6.2-28.4 c-0.3-0.8,0.2-1.5,1-1.5l14.5,0.5C161.6,234.7,162.4,235.3,162.7,236.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M161,236.1l6.2,28.4c0.3,0.8-0.2,1.5-1,1.5l-14.5-0.5c-0.9-0.1-1.7-0.7-2-1.6l-6.2-28.4 c-0.3-0.8,0.2-1.5,1-1.5l14.5,0.5C159.9,234.6,160.7,235.2,161,236.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157,237.3c0,0.7,0.5,1.2,1.2,1.3c0.7,0,1.2-0.5,1.3-1.2c0-0.7-0.5-1.2-1.2-1.3l0,0 C157.6,236,157,236.6,157,237.3L157,237.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M208.2,281c-8.6,17.3-27.6,39.7-35.3,39.6c-3.6,0-10.1,0.7-14.8-3.6c-10.2-9.4-18.5-27-20.1-37 c-0.6-3.6,16.9-10.9,19.4-7.9c5.8,6.9,12.4,20.4,13.5,20.3c3.9-0.2,19.5-12.6,30.4-21.3C214.6,260.5,211.7,274.1,208.2,281z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M138.1,261.6c2-7.2,3.6-8.7,2.1-15.6c-1-4.6,1.5-7.1,4.6-3.4c5.1,6.1,4.5,15.9,3.3,19.2L138.1,261.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M138.9,283.1c0,0-3-10.1-1.6-18c1-5.4,4.3-17,19.7-22.8c3.6-1.4,9.8-0.8,4.7,3.7c-3.6,3.1-6.9,4-8.7,6.2 c0,0,7.8,1.7,9,5.4c1.1,3.2,1.9,6.6,2.5,9.9c-0.6,0.3-1.2,0.5-1.8,0.6c0,0,0.8,3.6-1.9,8.5L138.9,283.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M139,260.1c2.3-1.8,7.1-5.6,12.1-7.3c5.6-1.9,16.8-4.1,18.2,0.1c1,3-3.2,4.2-3.2,4.2s4.8,0.1,5.1,3 c0.3,2.7-3,3.4-3,3.4s2.9,0.6,2.7,3.2c-0.3,3.2-6.4,1.5-9.4,4.4C160.7,271.8,139,260.1,139,260.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M152.1,259c4.3-2.1,9.1-2.8,13.8-2c0.1,0,0.2,0.1,0.1,0.1C161.3,257.2,156.6,257.9,152.1,259 C152.1,259.1,152.1,259,152.1,259z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M154.2,264.6c4.4-1.7,9.3-2.1,13.9-1.2c0.1,0,0.2,0.1,0,0.1C163.4,263.4,158.7,263.8,154.2,264.6 C154.1,264.7,154.1,264.6,154.2,264.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200,299.8l-10.8-19.9c4.4-4,8.9-7.7,13.7-11.2c6.9-4.7,10.3-3.2,7.7,6.7C208.9,282.1,200,299.8,200,299.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.2,270.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0c0-0.4,0.3-0.7,0.7-0.7 C205.8,270,206.2,270.4,206.2,270.8z M197.6,281.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7l0,0c0.4,0,0.7-0.3,0.7-0.7 C198.3,282.3,198,281.9,197.6,281.9z M205.4,281.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0 C206.2,282.3,205.8,281.9,205.4,281.9z M193.6,276.1L193.6,276.1l-0.7,0.6v0.1c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0 C194.4,276.4,194.1,276.1,193.6,276.1L193.6,276.1z M201.5,276.1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7 l0,0C202.2,276.4,201.9,276.1,201.5,276.1z M209.4,276.1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.8c0.4,0,0.7-0.3,0.8-0.8 C210.1,276.4,209.8,276.1,209.4,276.1z M197.6,293.8c-0.3,0-0.5,0.1-0.6,0.4l0.6,1.1l0,0c0.4,0,0.7-0.3,0.7-0.8 C198.3,294.2,198,293.8,197.6,293.8z M193.6,288L193.6,288l0.6,1.1c0.1-0.1,0.1-0.3,0.1-0.4C194.4,288.3,194,288,193.6,288 L193.6,288z M201.5,288c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C202.2,288.3,201.9,288,201.5,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M200.8,296.8c-1.4-3-2.8-6-4.3-8.9c-0.8-1.5-1.6-2.9-2.4-4.3s-1.8-2.8-2.6-4.2c0-0.1-0.2,0-0.1,0.1 c0.9,1.4,1.5,2.9,2.3,4.4s1.6,2.9,2.3,4.3c1.5,2.9,3.1,5.8,4.6,8.7C200.7,296.9,200.8,296.8,200.8,296.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M210.6,275.4c-1.8,6.7-10.6,24.3-10.6,24.3l-4.2-7.8l13.4-25.9C211.6,266.4,212.2,269.3,210.6,275.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M211.3,230.9c1.8-3.4,6.8-8.8,13-7.5c13.2,2.7,12.6,22.5,22.7,34.6c12.2,14.7,13.1,27.6,3.4,30 c-10.9,2.7-21.8-8.5-22.1-33.2c-0.2-15.5-4.8-22.3-8-21.7c-2,0.4-3.9,1.4-5.5,2.8L211.3,230.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.9,246.3c0.2,2.4,0.1,4.9,0.1,7.4c0,2.5,0,4.9,0,7.3s0.2,4.9,0.5,7.3s0.8,4.8,1.5,7.1 c0.7,2.3,1.9,4.4,3.4,6.3c1.6,1.8,3.5,3.4,5.7,4.5c2.2,1.2,4.5,1.9,7,2c1.2,0.1,2.5,0,3.7-0.3c0.6-0.1,1.2-0.3,1.8-0.5 s1.2-0.5,1.7-0.8c-1,0.8-2.2,1.3-3.4,1.6c-1.2,0.3-2.5,0.5-3.8,0.5s-2.6-0.1-3.8-0.4s-2.5-0.8-3.6-1.3c-1.1-0.6-2.2-1.2-3.3-2 l-0.8-0.6l-0.7-0.6c-0.5-0.4-0.9-0.9-1.4-1.4c-1.6-2-2.9-4.2-3.7-6.6c-1.4-4.8-2-9.8-1.8-14.8c0-2.5,0.1-4.9,0.3-7.4 S227.8,248.8,227.9,246.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M212.1,229.5c0.9-1.4,2.1-2.7,3.3-3.9c1.3-1.1,2.8-1.9,4.4-2.3c1.6-0.4,3.3-0.5,4.9-0.2 c0.8,0.2,1.6,0.4,2.4,0.7c0.8,0.3,1.5,0.6,2.2,1.1c1.4,0.9,2.6,2.1,3.5,3.4c1,1.4,1.8,2.8,2.4,4.4c1.4,3.1,2.4,6.3,3.6,9.6 c1.1,3.3,2.5,6.5,4.1,9.5c1.7,3,3.7,5.8,5.9,8.5c2.2,2.6,4.2,5.4,6,8.3c0.9,1.4,1.6,3,2.1,4.6l0.3,1.2c0.1,0.4,0.1,0.8,0.2,1.3 l0.1,0.6v0.6v1.3c0.3-3.5-0.5-7-2.3-10c-1.7-3-3.6-5.9-5.8-8.6c-2-2.7-3.9-5.6-5.6-8.5c-1.6-3-2.9-6.1-4-9.4 c-1.2-3.2-2.2-6.5-3.7-9.6c-0.7-1.6-1.6-3.1-2.7-4.5c-1-1.4-2.3-2.6-3.8-3.6c-0.8-0.5-1.6-0.8-2.4-1.1c-0.8-0.3-1.7-0.5-2.6-0.6 c-3.5-0.6-7.2,0.6-9.7,3.1C214.1,226.6,213,228,212.1,229.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M208.4,232.9c0.2-1.2,1.3-2.7,2.1-2.8s6.3,3.4,6.6,5s-2.6,2.5-2.6,2.5L208.4,232.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.3,324.4c0,0,21.4-19.5,5.6-50.2c0,0-10,1.6-12.7,1.1c-8-1.6-14-6-23.1-9.4s-15.5-0.7-19.2,5.5 c-0.9,1.5-4.6,21.4-1.3,29.5c2.6,6.3,13,8.2,13,8.2S234.8,326.3,252.3,324.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.2,270.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0c0-0.4,0.3-0.7,0.7-0.7 C205.8,270,206.2,270.4,206.2,270.8z M213.3,270c-0.4,0-0.7,0.3-0.8,0.7c0,0.4,0.3,0.7,0.8,0.8c0.4,0,0.7-0.3,0.7-0.8 C214.1,270.4,213.8,270,213.3,270C213.4,270,213.3,270,213.3,270L213.3,270z M221.2,270c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C222,270.4,221.7,270,221.2,270L221.2,270L221.2,270z M229.1,270 c-0.4,0-0.7,0.3-0.8,0.7c0,0.4,0.3,0.7,0.8,0.8c0.4,0,0.7-0.3,0.7-0.8C229.9,270.4,229.5,270,229.1,270L229.1,270L229.1,270z  M209,265.6c0.1,0.1,0.3,0.1,0.4,0.1c0.4,0,0.7-0.2,0.7-0.6C209.7,265.2,209.4,265.4,209,265.6z M218,264.7 c-0.4-0.1-0.9-0.2-1.3-0.2c-0.1,0.1-0.2,0.3-0.1,0.4c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C218,264.9,218,264.8,218,264.7z  M205.5,281.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C206.2,282.3,205.9,281.9,205.5,281.9L205.5,281.9 L205.5,281.9z M213.4,281.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7l0,0c0.4,0,0.7-0.3,0.7-0.7 C214.1,282.3,213.8,281.9,213.4,281.9z M221.2,281.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0 C222,282.3,221.6,281.9,221.2,281.9L221.2,281.9L221.2,281.9z M229.1,281.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7l0,0 c0.4,0,0.7-0.3,0.7-0.7C229.9,282.3,229.5,281.9,229.1,281.9z M237,281.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 s0.7-0.3,0.7-0.7l0,0C237.8,282.3,237.4,281.9,237,281.9L237,281.9L237,281.9z M244.9,281.9c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C245.6,282.3,245.3,281.9,244.9,281.9L244.9,281.9L244.9,281.9z M252.8,281.9 c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7C253.5,282.3,253.2,281.9,252.8,281.9z M260.7,281.9 c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7l0,0C261.4,282.3,261.1,281.9,260.7,281.9L260.7,281.9 L260.7,281.9z M201.7,276.1c-0.1,0.5-0.2,0.9-0.3,1.5l0,0c0.4,0,0.7-0.3,0.7-0.8C202.2,276.5,202,276.2,201.7,276.1L201.7,276.1z  M209.4,276.1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.8c0.4,0,0.7-0.3,0.8-0.8C210.2,276.4,209.8,276.1,209.4,276.1 L209.4,276.1L209.4,276.1z M217.3,276.1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0 C218.1,276.5,217.7,276.1,217.3,276.1L217.3,276.1L217.3,276.1z M225.2,276.1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.8 c0.4,0,0.7-0.3,0.8-0.8C225.9,276.4,225.6,276.1,225.2,276.1L225.2,276.1L225.2,276.1z M233.1,276.1c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C233.8,276.5,233.5,276.1,233.1,276.1C233.1,276.1,233,276.1,233.1,276.1L233.1,276.1z  M241,276.1c-0.4,0-0.7,0.3-0.8,0.7c0,0.4,0.3,0.7,0.8,0.8c0.4,0,0.7-0.3,0.7-0.8C241.7,276.5,241.4,276.1,241,276.1L241,276.1 L241,276.1z M248.8,276.1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C249.6,276.5,249.3,276.1,248.8,276.1 C248.9,276.1,248.8,276.1,248.8,276.1L248.8,276.1z M256.7,276.1c-0.4,0-0.7,0.3-0.8,0.7c0,0.4,0.3,0.7,0.8,0.8 c0.4,0,0.7-0.3,0.7-0.8C257.5,276.5,257.2,276.1,256.7,276.1L256.7,276.1L256.7,276.1z M205.5,293.9c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C206.2,294.2,205.9,293.8,205.5,293.9C205.5,293.8,205.5,293.8,205.5,293.9L205.5,293.9 z M213.4,293.9c-0.4,0-0.7,0.3-0.8,0.7c0,0.4,0.3,0.7,0.8,0.8c0.4,0,0.7-0.3,0.7-0.8C214.1,294.2,213.8,293.8,213.4,293.9 C213.4,293.8,213.4,293.8,213.4,293.9L213.4,293.9z M221.2,293.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7 l0,0C222,294.2,221.7,293.8,221.2,293.9C221.3,293.8,221.2,293.8,221.2,293.9L221.2,293.9z M229.1,293.9c-0.4,0-0.7,0.3-0.8,0.7 c0,0.4,0.3,0.7,0.8,0.8c0.4,0,0.7-0.3,0.7-0.8C229.9,294.2,229.6,293.8,229.1,293.9C229.1,293.8,229.1,293.8,229.1,293.9 L229.1,293.9z M237,293.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C237.8,294.2,237.4,293.8,237,293.9 C237,293.8,237,293.8,237,293.9L237,293.9z M244.9,293.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0 C245.7,294.2,245.3,293.8,244.9,293.9C244.9,293.8,244.9,293.8,244.9,293.9L244.9,293.9z M252.8,293.9c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.8c0.4,0,0.7-0.3,0.8-0.8C253.5,294.2,253.2,293.8,252.8,293.9C252.8,293.8,252.8,293.8,252.8,293.9 L252.8,293.9z M260.7,293.9c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7l0,0 C261.4,294.2,261.1,293.8,260.7,293.9C260.7,293.8,260.7,293.8,260.7,293.9L260.7,293.9z M201.5,288c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C202.2,288.3,201.9,288,201.5,288z M209.4,288c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7C210.1,288.3,209.8,288,209.4,288z M217.3,288c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C218,288.3,217.7,288,217.3,288z M225.2,288c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7l0,0c0.4,0,0.7-0.3,0.7-0.7S225.6,288,225.2,288z M233,288c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 s0.7-0.3,0.7-0.7l0,0C233.8,288.3,233.4,288,233,288L233,288L233,288z M240.9,288c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 s0.7-0.3,0.7-0.7C241.7,288.3,241.3,288,240.9,288z M248.8,288c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0 C249.6,288.3,249.2,288,248.8,288L248.8,288L248.8,288z M256.7,288c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7 C257.4,288.3,257.1,288,256.7,288z M213.3,305.7c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7l0,0c0.4,0,0.7-0.3,0.7-0.7 C214.1,306.1,213.7,305.7,213.3,305.7z M221.2,305.7c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0 C222,306.1,221.6,305.7,221.2,305.7L221.2,305.7L221.2,305.7z M229.1,305.7c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 s0.7-0.3,0.7-0.7C229.8,306.1,229.5,305.7,229.1,305.7z M237,305.7c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7 l0,0C237.7,306.1,237.4,305.7,237,305.7L237,305.7z M244.9,305.7c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7 l0,0C245.6,306.1,245.3,305.7,244.9,305.7L244.9,305.7L244.9,305.7z M252.8,305.7c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 s0.7-0.3,0.7-0.7C253.5,306.1,253.2,305.7,252.8,305.7z M260.6,305.7c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7l0,0C261.4,306.1,261.1,305.7,260.6,305.7L260.6,305.7L260.6,305.7z M201.5,299.9c-0.1,0-0.2,0-0.3,0.1 c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.1,0.1,0.3,0.2,0.4c0.3-0.1,0.5-0.4,0.5-0.7C202.2,300.2,201.9,299.9,201.5,299.9L201.5,299.9 L201.5,299.9z M209.4,299.9c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8C210.1,300.2,209.8,299.9,209.4,299.9 L209.4,299.9z M217.3,299.9c-0.4,0-0.8,0.3-0.8,0.7c0,0.4,0.3,0.8,0.7,0.8s0.8-0.3,0.8-0.7l0,0C218,300.2,217.7,299.9,217.3,299.9 L217.3,299.9L217.3,299.9z M225.2,299.9c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8 C225.9,300.2,225.6,299.9,225.2,299.9L225.2,299.9z M233,299.9c-0.4,0-0.8,0.3-0.8,0.7c0,0.4,0.3,0.8,0.7,0.8s0.8-0.3,0.8-0.7l0,0 C233.8,300.2,233.5,299.9,233,299.9L233,299.9L233,299.9z M240.9,299.9c-0.4,0-0.8,0.2-0.8,0.7c0,0.4,0.2,0.8,0.7,0.8 c0.1,0,0.1,0,0.2,0c0.4,0,0.7-0.4,0.7-0.8C241.5,300.2,241.3,299.9,240.9,299.9z M248.8,299.9c-0.4,0-0.8,0.3-0.8,0.7 c0,0.4,0.3,0.8,0.7,0.8s0.8-0.3,0.8-0.7l0,0C249.6,300.2,249.2,299.9,248.8,299.9L248.8,299.9L248.8,299.9z M256.7,299.9 c-0.4,0-0.8,0.2-0.8,0.7c0,0.4,0.2,0.8,0.7,0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.7-0.4,0.7-0.8C257.3,300.2,257,299.9,256.7,299.9z  M229.1,317.6c-0.4,0-0.7,0.3-0.7,0.7c0.4,0.2,0.8,0.4,1.2,0.6c0.2-0.1,0.3-0.3,0.3-0.6C229.8,318,229.5,317.6,229.1,317.6 L229.1,317.6L229.1,317.6z M237,317.6c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0 C237.7,318,237.4,317.6,237,317.6L237,317.6z M244.9,317.6c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0 C245.6,318,245.3,317.6,244.9,317.6L244.9,317.6L244.9,317.6z M252.8,317.6c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.8 c0.4,0,0.7-0.3,0.8-0.8C253.5,318,253.2,317.6,252.8,317.6L252.8,317.6L252.8,317.6z M225.2,311.8c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7C225.9,312.1,225.6,311.8,225.2,311.8z M233,311.8c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C233.8,312.1,233.5,311.8,233,311.8L233,311.8L233,311.8z M240.9,311.8 c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7l0,0c0.4,0,0.7-0.3,0.7-0.7C241.7,312.1,241.3,311.8,240.9,311.8z M248.8,311.8 c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C249.6,312.1,249.2,311.8,248.8,311.8L248.8,311.8L248.8,311.8z  M256.7,311.8c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7C257.4,312.1,257.1,311.8,256.7,311.8z M248.8,323.7 c-0.4,0-0.7,0.3-0.7,0.8v0.1h1.5v-0.1C249.5,324,249.2,323.7,248.8,323.7L248.8,323.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.4,272.4c10.1,17.3,23,46,15,51c-13.1,8.3-48.6,9.5-56.8,9.4c-3.5,0-7.5-23.4-4.9-26s39.7,0,40.3-2.2 c0.3-1.3-1.3-12.6-3.1-26.7C214.7,261.5,223.5,267.4,226.4,272.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186,305.7c0,0-10.5-1.4-17.5-2c-3.9-0.3-10.6-0.3-13.5,0.7c-4.4,1.6-21.9,11-19.7,15.3c2,3.9,16-6.1,16-6.1 s-15,8.8-11.8,13.1s17.6-9.2,17.6-9.2s-15.2,9.4-11.2,13.3c3.1,2.9,16.7-8.5,16.7-8.5s-13,8.2-10,11.3c3.3,3.5,16.6-6.3,16.6-6.3 c9,6.6,16,6.1,20.9,5.2C191.3,332.2,186,305.7,186,305.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M156.3,310.1c-1.8,1-3.6,2-5.4,3.1s-3.4,2.3-5,3.6c-2.1,1.6-4,3.5-5.7,5.6c3.3-3.5,9.3-7.6,11-8.7 S154.5,311.3,156.3,310.1L156.3,310.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M160.5,316.2c-2.2,1.3-4.5,2.6-6.7,4s-4.1,3-6.2,4.6c-0.2,0.1-0.1,0.2,0.1,0c2.1-1.5,4.2-2.7,6.4-4.2 S158.3,317.6,160.5,316.2C160.5,316.3,160.5,316.2,160.5,316.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165,320.8c-3.5,2-6.8,4.3-9.8,7c-0.1,0.1,0,0.2,0.2,0c3.2-2.4,5.7-4.3,9.7-6.9 C165.1,320.9,165.1,320.8,165,320.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M196,305.4c-1.5-0.1-6.7,0.2-10.1-0.1c-7.9-0.7-18.9-2.2-22.9-2.4c-4.7-0.2-7.9,0.6-10,2.1 c-0.8,0.6-1.1,1-0.3,0.5c3.5-1.8,6.2-2.2,11.2-2c3.5,0.1,14,1.6,21.9,2.2c3.4,0.2,6.8,0.1,10.2-0.1 C196.1,305.5,196.1,305.4,196,305.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.2,294.3l-22.4-3c0,0-1.3-11.3-1.1-17.6c0.3-8.4,3.4-10.3,10-2.3C230.1,276.7,239.2,294.3,239.2,294.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M222,270.8c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7l0,0c0-0.4,0.3-0.7,0.7-0.7C221.7,270,222,270.4,222,270.8 L222,270.8z M221.3,281.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C222,282.3,221.7,281.9,221.3,281.9 C221.2,281.9,221.2,281.9,221.3,281.9L221.3,281.9z M229.1,281.9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7 C229.9,282.3,229.6,281.9,229.1,281.9L229.1,281.9z M217.3,276.1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7 l0,0C218.1,276.4,217.7,276.1,217.3,276.1L217.3,276.1L217.3,276.1z M225.2,276.1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.8 c0.4,0,0.7-0.3,0.8-0.8C225.9,276.4,225.6,276.1,225.2,276.1L225.2,276.1L225.2,276.1z M237,293.8c-0.1,0-0.3,0-0.4,0.1l0.9,0.1 C237.4,293.9,237.2,293.8,237,293.8z M217.3,288c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0 C218,288.3,217.7,288,217.3,288z M225.2,288c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7l0,0c0.4,0,0.7-0.3,0.7-0.7 S225.6,288,225.2,288z M233,288c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0,0C233.8,288.3,233.4,288,233,288 L233,288L233,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M219.5,291.7c-0.2-0.1-2.5-0.5-2.7-0.4c-0.1-1.3-0.7-7.5-0.8-8.2c0-0.1-0.1-0.1-0.1,0c0,0.4,0,1.8,0.1,3.4 c0,0,0,0,0-0.1c-0.1-0.3-0.3-0.6-0.4-0.9s-0.2-0.6-0.3-0.9c0-0.1-0.2,0-0.1,0.1c0.1,0.3,0.2,0.6,0.3,0.9s0.2,0.6,0.3,0.9 s0.2,0.5,0.3,0.8l0,0c0.1,1.8,0.2,3.6,0.2,4.3C217.4,291.7,218.5,291.7,219.5,291.7C219.6,291.7,219.6,291.7,219.5,291.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M237.2,291.9c-3.2-0.7-6.5-1.3-9.7-1.7c-1.6-0.2-3.3-0.4-4.9-0.6s-3.3-0.2-4.9-0.4c-0.1,0-0.1,0.1,0,0.1 c1.6,0.1,3.3,0.5,4.9,0.7s3.3,0.4,4.9,0.6c3.3,0.5,6.5,0.9,9.8,1.4C237.3,292,237.3,291.9,237.2,291.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M232.6,281.9C232.6,281.9,232.5,281.9,232.6,281.9c0.3,1,4.9,9.9,6.4,12.2c-0.6-0.1-1.2-0.1-1.8-0.1 c0.7,0.2,1.5,0.3,2.3,0.4C239.6,294.4,233.3,282.7,232.6,281.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M202.3,270.2c-1.6,4.3-2.5,17.8,2.1,17.7s12.4-16.4,11.5-20.6S204.7,263.7,202.3,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M212.9,269.1c-0.1,1-4.4,8-9,8.2c-1.5,0.1-2.2-8.1-2.2-8.1l-0.2-0.6l-2.7-8.3l9.4-7.3l1.4-1 c0,0,0.6,2.3,1.3,5.2c0,0.1,0.1,0.3,0.1,0.4l0.1,0.5c0.1,0.4,0.2,0.9,0.3,1.3s0.1,0.7,0.2,1s0.1,0.7,0.2,1 C212.4,264,212.7,266.5,212.9,269.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M210.9,257.2c-1.3,5-4.7,9.1-9.4,11.4l-2.7-8.3l9.4-7.3l1.4-1C209.6,252,210.1,254.3,210.9,257.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186.1,245.4c-2.4,15.2,6.4,18.3,9.7,18.8c3,0.5,13.1,1.6,17-13.2s-2.4-20.7-9.1-22.1S188.4,230.3,186.1,245.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.2,243.6c0.4,0,0.7-0.1,1.1-0.1c0.4,0,0.7-0.1,1-0.3c0.2-0.2,0.2-0.5,0.1-0.7c-0.3-0.4-0.8-0.5-1.3-0.4 c-0.5,0-1,0.2-1.3,0.6c-0.2,0.2-0.2,0.6,0,0.8C188.9,243.5,189,243.6,189.2,243.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M199.1,244.6c-0.3-0.1-0.7-0.2-1-0.3c-0.4,0-0.7-0.2-1-0.5c-0.1-0.2-0.1-0.5,0.1-0.7c0.4-0.3,0.9-0.4,1.4-0.2 c0.5,0.1,0.9,0.4,1.2,0.8c0.2,0.3,0.1,0.6-0.2,0.8C199.4,244.6,199.2,244.7,199.1,244.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M196.7,248.3l0.1,0.1c-0.1,1-0.1,2.3,0.8,2.7v0.1C196.4,250.9,196.4,249.3,196.7,248.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M197.8,247.3c1.7,0,1.4,3.4-0.1,3.4S196.4,247.3,197.8,247.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M198.4,247.6c0.3,0.2,0.6,0.6,0.9,0.6s0.7-0.3,1-0.6h0.1c0,0.6-0.3,1.3-1,1.3s-1-0.6-1.2-1.2 C198.2,247.6,198.3,247.5,198.4,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M190.9,247.6C190.9,247.6,190.8,247.6,190.9,247.6c-0.1,1.1-0.3,2.3-1.3,2.6v0.1 C190.8,250.1,191.1,248.6,190.9,247.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M190.1,246.4c-1.7-0.2-2,3.1-0.5,3.3S191.4,246.6,190.1,246.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.3,246.6c-0.3,0.1-0.6,0.4-0.9,0.4s-0.6-0.4-0.8-0.8c0,0,0,0-0.1,0c-0.1,0.6,0.1,1.3,0.7,1.5 S189.2,247.4,189.3,246.6C189.5,246.7,189.4,246.5,189.3,246.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M196.1,256.3c-0.3,0.2-0.5,0.6-0.9,0.6s-0.8-0.1-1.1-0.3H194c0.3,0.4,0.8,0.7,1.3,0.6S196.1,256.8,196.1,256.3 C196.2,256.3,196.2,256.3,196.1,256.3C196.1,256.2,196.1,256.2,196.1,256.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.1,252.1c0,0-0.3,1.5-0.4,2.3c0,0.1,0.2,0.1,0.4,0.1l0,0c1.3,0.3,2.6,0,3.5-1c0-0.1,0-0.1-0.1-0.1 c-1,0.6-2.1,0.8-3.3,0.6c0-0.2,0.7-2.6,0.6-2.6c-0.6,0-1.1,0.1-1.7,0.2c0.6-3.2,1.7-6.3,2.3-9.5c0-0.1,0-0.1-0.1-0.1 s-0.1,0-0.1,0.1l0,0c-1.3,3.3-2.3,6.7-2.9,10.2C190.2,252.7,191.8,252.3,192.1,252.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M192.5,254.4c0.4,0.6,0.8,1,1.4,1.4c0.3,0.2,0.7,0.2,1.1,0.2c0.8-0.1,0.9-0.8,0.8-1.4c0-0.3-0.1-0.7-0.3-1 C194.6,254.1,193.6,254.4,192.5,254.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M193.9,255.7c0.3,0.2,0.7,0.2,1.1,0.2c0.8-0.1,0.9-0.8,0.8-1.4C194.9,254.4,194.2,254.9,193.9,255.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M212.5,252c-3.9-0.4-4.2-12.6-4.2-14.1c0,0.9-0.3,5.9-0.6,6.1c-0.4,0-0.8-0.2-1.2-0.3l0,0c0-0.6,0-1.2,0-1.8 c0-0.3-0.1,0.6-0.4,1.7l-0.7-0.3c0.1-1.3,0.1-2.6-0.1-3.8c-0.1-0.5-0.4,1.6-0.9,3.5c-3.3-1.2-6.7-2.1-10.2-2.6 c-1-0.1-1.8-0.2-2.6-0.2c0.1-1.5,0.4-3,0.3-2.7c-0.4,0.9-0.6,1.8-0.8,2.7H190c0.1-2.1,1.3-5.3,0.9-4.9c-1.1,1.5-1.9,3.2-2.4,5 c-1.4,0.2-1.9,0.4-1.9,0c0.7-4.1,2.8-7.7,6-10.4c5.3-4.3,15.2-4.7,20.2,2.8c0,0,4.4,3.3,4.7,8.2S214.8,252.2,212.5,252z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M210.2,251.8c0,0,3.7-4.6,5.8-3.2s-0.9,8.1-3.5,8.9c-1.3,0.5-2.8-0.2-3.3-1.5v-0.1L210.2,251.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M215.1,250.6L215.1,250.6c-1.8,0.7-2.9,2.3-3.7,3.9c0.4-0.7,1.3-0.8,2-0.4c0.1,0,0.1,0.1,0.2,0.1 c0,0,0,0.1-0.1,0.1c-0.6-0.3-1.3-0.1-1.8,0.4c-0.4,0.4-0.7,0.9-0.9,1.4c-0.1,0.1-0.4,0-0.3-0.1l0,0 C210.6,253.7,212.6,250.6,215.1,250.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 42,
    cy: 300.4,
    r: 2.7
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "257.8,186.3 264.1,201.5 257.8,204.1 251.5,188.8 241.2,196.9 241.2,154.2 271,184.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M241.5,148.6c-0.3-0.9-0.5-1.9-0.5-2.8c0-1,0.2-1.9,0.5-2.8c0.4,0.9,0.5,1.9,0.5,2.8 C242,146.7,241.9,147.7,241.5,148.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M236.7,150.6c-1.8-0.8-3.2-2.2-4-4c0.9,0.4,1.7,1,2.4,1.6C235.7,148.9,236.3,149.7,236.7,150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M234.6,155.4c-1.8,0.7-3.8,0.7-5.6,0C230.8,154.8,232.8,154.8,234.6,155.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M236.7,160.3c-0.8,1.8-2.2,3.2-4,4c0.4-0.9,0.9-1.7,1.6-2.4C235,161.3,235.8,160.7,236.7,160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M248.4,155.4c1.8-0.7,3.8-0.7,5.6,0C252.2,156.1,250.2,156.1,248.4,155.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M246.4,150.6c0.4-0.9,1-1.7,1.6-2.4c0.7-0.7,1.5-1.3,2.4-1.6c-0.4,0.9-1,1.7-1.6,2.4 C248.1,149.6,247.3,150.2,246.4,150.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg401Unauthorized);
export default __webpack_public_path__ + "static/media/401-unauthorized.3d4456fcc2a194c82439a6bb8f5f69dc.svg";
export { ForwardRef as ReactComponent };